import { ROLE_BOM } from "@/lib/utils";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CurrentDataSlice {
  communityData: any;
  prevCommunityData: any;
  propertyData: any;
  userData: any;
  stateData: any;
  budgetData: any;
  loggedInUserData: any;
  lineItemList: any;
  userDataAction: any;
  currentFinanceYear: any;
  forgotPwdEmail: string;
  activityDashboardOpenTab: string[];
  accessPermission: any;
  invoiceIds: any;
  paymentIds: any;
  invoiceFrom: any;
  allInvoiceStatus: any;
  myCommunityCurrView: any; // use only for bom and owner role
  currentRole: string; // use only for bom and owner role
  vendors: any; // use only for bom and owner role
  glMaster: any; // use only for bom and owner role
  invoiceDueDate: any; // use only for bom
  pendingBillingAmt: any; // use only for Owner
  tncStatus: any; // use only for Owner
  fiscalYearDtl: any;
  auditTrailDtl: any;
  distributionJobDtl: any;
  bulkUploadDtl: any;
  metricData: any;
  masterDataPermission: any;
  ocpData: any;
  pendingBillData: any;
}

const initialState: CurrentDataSlice = {
  communityData: null,
  prevCommunityData: null,
  propertyData: null,
  userData: null,
  stateData: null,
  budgetData: null,
  loggedInUserData: null,
  lineItemList: null,
  userDataAction: null,
  currentFinanceYear: null,
  forgotPwdEmail: "",
  activityDashboardOpenTab: ["invoice"],
  accessPermission: null,
  invoiceIds: "",
  paymentIds: "",
  invoiceFrom: "",
  allInvoiceStatus: "",
  myCommunityCurrView: "",
  currentRole: ROLE_BOM,
  vendors: [],
  glMaster: [],
  invoiceDueDate: null,
  pendingBillingAmt: null,
  tncStatus: null,
  fiscalYearDtl: null,
  auditTrailDtl: null,
  distributionJobDtl: null,
  bulkUploadDtl: null,
  metricData: null,
  masterDataPermission: null,
  ocpData: null,
  pendingBillData: "0"
};

const currentDataSlice = createSlice({
  name: "currentData",
  initialState,
  reducers: {
    setCommunityData(state, action: PayloadAction<any | null>) {
      state.communityData = action.payload;
    },
    setPrevCommunityData(state, action: PayloadAction<CurrentDataSlice | null>) {
      state.prevCommunityData = action.payload;
    },
    setTncStatus(state, action: PayloadAction<CurrentDataSlice | null>) {
      state.tncStatus = action.payload;
    },
    clearCommunityData(state) {
      state.communityData = null;
    },
    setPropertyData(state, action: PayloadAction<any>) {
      state.propertyData = action.payload;
    },
    clearPropertyData(state) {
      state.propertyData = null;
    },
    setUserData(state, action: PayloadAction<CurrentDataSlice>) {
      state.userData = action.payload;
    },
    clearUserData(state) {
      state.userData = null;
    },
    setStateData(state, action: PayloadAction<CurrentDataSlice>) {
      state.stateData = action.payload;
    },
    clearStateData(state) {
      state.stateData = null;
    },
    setBudgetData(state, action: PayloadAction<CurrentDataSlice>) {
      state.budgetData = action.payload;
    },
    clearBudgetData(state) {
      state.budgetData = null;
    },
    setLoggedInUserData(state, action: PayloadAction<CurrentDataSlice>) {
      state.loggedInUserData = action.payload;
    },
    clearLoggedInUserData(state) {
      state.loggedInUserData = null;
    },
    setLineItemList(state, action: PayloadAction<CurrentDataSlice>) {
      state.lineItemList = action.payload;
    },
    clearLineItemList(state) {
      state.lineItemList = null;
    },
    setUserDataAction(state, action: PayloadAction<string>) {
      state.userDataAction = action.payload;
    },
    clearUserDataAction(state) {
      state.userDataAction = null;
    },
    setCurrentFinanceYear(state, action: PayloadAction<string>) {
      state.currentFinanceYear = action.payload;
    },
    setForgotPwdEmail(state, action: PayloadAction<string>) {
      state.forgotPwdEmail = action.payload;
    },
    setActivityDashboardOpenTab(state, action: PayloadAction<string[]>) {
      state.activityDashboardOpenTab = action.payload;
    },
    setAccessPermission(state, action: PayloadAction<any>) {
      state.accessPermission = action.payload;
    },
    setInvoiceIds(state, action: PayloadAction<any>) {
      state.invoiceIds = action.payload;
    },
    setPaymentIds(state, action: PayloadAction<any>) {
      state.paymentIds = action.payload;
    },
    setInvoiceFrom(state, action: PayloadAction<string>) {
      state.invoiceFrom = action.payload;
    },
    setAllInvoiceStatus(state, action: PayloadAction<string>) {
      state.allInvoiceStatus = action.payload;
    },
    setMyCommunityCurrView(state, action: PayloadAction<string>) {
      state.myCommunityCurrView = action.payload;
    },
    setCurrentRole(state, action: PayloadAction<string>) {
      state.currentRole = action.payload;
    },
    setVendors(state, action: PayloadAction<any>) {
      state.vendors = action.payload;
    },
    setGls(state, action: PayloadAction<any>) {
      state.glMaster = action.payload;
    },
    setInvoiceDueDate(state, action: PayloadAction<any>) {
      state.invoiceDueDate = action.payload;
    },
    setPendingBillingAmt(state, action: PayloadAction<any>) {
      state.pendingBillingAmt = action.payload;
    },
    setFiscalYearDtl(state, action: PayloadAction<any>) {
      state.fiscalYearDtl = action.payload;
    },
    setAuditTrailDtl(state, action: PayloadAction<any>) {
      state.auditTrailDtl = action.payload;
    },
    setDistributionJobDtl(state, action: PayloadAction<any>) {
      state.distributionJobDtl = action.payload;
    },
    setBulkUploadDtl(state, action: PayloadAction<any>) {
      state.bulkUploadDtl = action.payload;
    },
    setMetricData(state, action: PayloadAction<any>) {
      state.metricData = action.payload;
    },
    setMasterDataPermission(state, action: PayloadAction<any>) {
      state.masterDataPermission = action.payload;
    },
    setOCPData(state, action: PayloadAction<any>) {
      state.ocpData = action.payload;
    },
    setPendingBillData(state, action: PayloadAction<any>) {
      state.pendingBillData = action.payload;
    },
    reset(state) {
      state.communityData = null;
      state.propertyData = null;
      state.userData = null;
      state.stateData = null;
      state.budgetData = null;
      state.loggedInUserData = null;
      state.lineItemList = null;
      state.userDataAction = null;
      state.currentFinanceYear = null;
      state.forgotPwdEmail = "";
      state.activityDashboardOpenTab = ["invoice"];
      state.accessPermission = null;
      state.invoiceIds = "";
      state.invoiceFrom = "";
      state.allInvoiceStatus = "";
      state.myCommunityCurrView = "";
      state.currentRole = ROLE_BOM;
      state.vendors = [];
      state.invoiceDueDate = [];
      state.pendingBillingAmt = null;
      state.tncStatus = null;
      state.fiscalYearDtl = null;
      state.auditTrailDtl = null;
      state.distributionJobDtl = null;
      state.bulkUploadDtl = null;
      state.metricData = null;
      state.masterDataPermission = null;
      state.ocpData = null;
      state.pendingBillData = null;
    },
  },
});

export const {
  setCommunityData,
  clearCommunityData,
  setPropertyData,
  clearPropertyData,
  setUserData,
  clearUserData,
  setStateData,
  clearStateData,
  setBudgetData,
  clearBudgetData,
  setLoggedInUserData,
  clearLoggedInUserData,
  reset,
  setLineItemList,
  clearLineItemList,
  setUserDataAction,
  clearUserDataAction,
  setCurrentFinanceYear,
  setForgotPwdEmail,
  setActivityDashboardOpenTab,
  setAccessPermission,
  setInvoiceIds,
  setPaymentIds,
  setInvoiceFrom,
  setAllInvoiceStatus,
  setMyCommunityCurrView,
  setCurrentRole,
  setVendors,
  setGls,
  setInvoiceDueDate,
  setPendingBillingAmt,
  setPrevCommunityData,
  setTncStatus,
  setFiscalYearDtl,
  setAuditTrailDtl,
  setDistributionJobDtl,
  setBulkUploadDtl,
  setMetricData,
  setMasterDataPermission,
  setOCPData,
  setPendingBillData
} = currentDataSlice.actions;

export default currentDataSlice.reducer;
